import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  CardActions
} from '@mui/material';

const EbraryCourses = () => {
  const [courses, setCourses] = useState([]);
  const [user, setUser] = useState(null);
  const [enrolledCourses, setEnrolledCourses] = useState([]);


  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    setUser(storedUser);
  
    if (storedUser && storedUser._id) {
      axios
        .get(`https://backend.scholarkart.in/api/users/${storedUser._id}/enrolled-courses`)
        .then((res) => setEnrolledCourses(res.data))
        .catch((err) => console.error('Error fetching enrolled courses:', err));
    }
  
    fetchCourses(storedUser); // ⬅️ pass user object to fetchCourses
  }, []);
  

  const fetchCourses = async (user) => {
    try {
      const collegeId = user?.collegeId;
  
      if (collegeId) {
        const mapRes = await axios.get(`https://backend.scholarkart.in/api/course-mapping?collegeId=${collegeId}`);
        const mapped = mapRes.data;
  
        console.log("✅ course-college mappings raw:", mapped);
  
        if (mapped.length > 0) {
          const courseIds = mapped.map(m => m.courseId?.toString()).filter(Boolean).join(',');
  
          console.log("✅ Mapped courseIds:", courseIds);
  
          if (courseIds.length > 0) {
            const coursesRes = await axios.get(`https://backend.scholarkart.in/api/courses?courseIds=${courseIds}`);
            setCourses(coursesRes.data || []);
          } else {
            console.warn("❌ Mapped list is non-empty but courseIds extraction failed.");
            setCourses([]);
          }
        } else {
          console.warn('✅ No mapped courses for this college');
          setCourses([]);
        }
  
      } else {
        const allCoursesRes = await axios.get('https://backend.scholarkart.in/api/courses');
        setCourses(allCoursesRes.data || []);
      }
    } catch (error) {
      console.error('🔥 Error fetching courses:', error);
      setCourses([]);
    }
  };
  
  

  const handleEnroll = async (courseId) => {
    try {
      if (!user || !user._id) {
        alert('Please log in to enroll.');
        return;
      }
  
      console.log("Trying to enroll:", { userId: user._id, courseId });
  
      await axios.post(`https://backend.scholarkart.in/api/enroll`, {
        userId: user._id,
        courseId
      });
  
      const response = await axios.get(`https://backend.scholarkart.in/api/users/${user._id}/enrolled-courses`);
      setEnrolledCourses(response.data);
  
      alert('Enrolled successfully!');
    } catch (error) {
      console.error('Enrollment failed:', error);
      alert('Enrollment failed');
    }
  };
  

  // Group courses by affiliation
const groupedCourses = courses.reduce((groups, course) => {
  const affiliation = course.affiliation || 'Other';
  if (!groups[affiliation]) {
    groups[affiliation] = [];
  }
  groups[affiliation].push(course);
  return groups;
}, {});

const handleAccessCourse = (courseId) => {
  // You can change the route based on your course viewer
  window.location.href = `/course/${courseId}`;
};

const handleUnenroll = async (courseId) => {
  if (!user || !user._id) return;

  try {
    const confirm = window.confirm('Are you sure you want to unenroll from this course?');
    if (!confirm) return;

    await axios.post(`https://backend.scholarkart.in/api/unenroll`, {
      userId: user._id,
      courseId: courseId
    });

    // Refresh enrolled courses
    const response = await axios.get(`https://backend.scholarkart.in/api/users/${user._id}/enrolled-courses`);
    setEnrolledCourses(response.data);

    alert('Unenrolled successfully.');
  } catch (error) {
    console.error('Error during unenrollment:', error);
    alert('Failed to unenroll.');
  }
};

  return (
    <Box sx={{ p: 4 }}>
      {enrolledCourses.length > 0 && (
        <Box sx={{ mb: 5 }}>
          <Typography variant="h5" sx={{ mb: 2, color: 'green' }}>
            ✅ Enrolled Courses
          </Typography>
          <Grid container spacing={3}>
            {enrolledCourses.map((course) => (
              <Grid item xs={12} sm={6} md={4} key={course._id}>
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', border: '1px solid #d4edda' }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>{course.courseName}</Typography>
                    <Typography variant="body2" sx={{ mb: 1 }} color="text.secondary">
                      {course.description.length > 120
                        ? course.description.slice(0, 120) + '...'
                        : course.description}
                    </Typography>
                    <Typography variant="body2"><strong>Affiliation:</strong> {course.affiliation}</Typography>
                    <Typography variant="body2"><strong>Course Duration:</strong> {course.subscriptionPeriod} Years</Typography>
                  </CardContent>
                  <CardActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => handleAccessCourse(course._id)}
                    >
                      Access Course
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => handleUnenroll(course._id)}
                    >
                      Unenroll
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}


    <Typography variant="h4" gutterBottom>Available Courses</Typography>
  
    {Object.entries(groupedCourses).map(([affiliation, courseList]) => {
      // Sort each group alphabetically by courseName
      const sortedCourses = courseList.sort((a, b) =>
        a.courseName.localeCompare(b.courseName)
      );
  
      return (
        <Box key={affiliation} sx={{ mb: 4 }}>
          <Typography variant="h5" sx={{ mb: 2, color: 'darkblue' }}>
            🎓 {affiliation}
          </Typography>
  
          <Grid container spacing={3}>
            {sortedCourses.map((course) => (
              <Grid item xs={12} sm={6} md={4} key={course._id}>
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>{course.courseName}</Typography>
                    <Typography variant="body2" sx={{ mb: 1 }} color="text.secondary">
                      {course.description.length > 120
                        ? course.description.slice(0, 120) + '...'
                        : course.description}
                    </Typography>
                    <Typography variant="body2"><strong>Affiliation:</strong> {course.affiliation}</Typography>
                    <Typography variant="body2"><strong>Course Duration:</strong> {course.subscriptionPeriod} Years</Typography>
                  </CardContent>
                  <CardActions sx={{ mt: 'auto', justifyContent: 'flex-end' }}>
                    <Button variant="contained" onClick={() => handleEnroll(course._id)}>
                      Enroll Now
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      );
    })}
  </Box>
  );
};

export default EbraryCourses;
